import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { setExtraOralExamination } from "../../../../../redux/diagnosestate/diagnoseAction";

const FIELDS = [
  { key: "facialAsymmetry", label: "Facial asymmetry" },
  { key: "swellings", label: "Swellings" },
  { key: "scars", label: "Scars" },
  { key: "lymphadenopathy", label: "Lymphadenopathy" },
  { key: "other", label: "Other" },
] as const;

function ExtraOralExamination() {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const extraOralExamination = useSelector(
    (state: RootState) => state.diagnose.extraOralExamination
  ) || {  
    facialAsymmetry: "",
    swellings: "",
    scars: "",
    lymphadenopathy: "",
    other: "",
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    dispatch(setExtraOralExamination({ [name]: value }));
  };

  return (
    <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="w-full px-4 py-2.5 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between gap-2 text-left hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors"
      >
        <h4 className="text-sm font-bold text-slate-800 dark:text-slate-100">
          Extra oral examination
        </h4>
        <svg
          className={`w-4 h-4 text-slate-500 dark:text-slate-400 shrink-0 transition-transform duration-300 ease-in-out ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="min-h-0 overflow-hidden">
          <div className="p-4 grid grid-cols-2 gap-4">
            {FIELDS.map(({ key, label }) => (
              <div key={key}>
                <label className="block text-xs font-medium text-slate-700 dark:text-slate-400 mb-1">
                  {label}
                </label>
                <textarea
                  name={key}
                  rows={3}
                  value={extraOralExamination[key] ?? ""}
                  onChange={handleChange}
                  placeholder={`Enter ${label.toLowerCase()}...`}
                  className="w-full px-3 py-2 rounded-lg border border-gray-600 dark:border-slate-600 focus:outline-none transition-all resize-none text-xs bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExtraOralExamination;
